import styled, { css } from 'styled-components';

export const CustomOrderAddEventItemSC = styled.div<{
  textColor: string;
  backgroundColor: string;
}>`
  width: 100%;
  height: 100%;
  border-radius: 5px;

  font-size: 11px;
  font-weight: bold;

  .content {
    padding: 2px 4px;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    .name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    ${({ textColor, backgroundColor }) => {
      // ${type === 'premium' ? '#FF4496' : color ? color : '#'}
      return css`
        border: 1px solid transparent;
        background: ${backgroundColor};
        color: ${textColor};
        font-style: normal;
        font-weight: 800;
        font-size: 11px;
        line-height: 14px;
      `;
    }}
  }
`;
